<script setup lang="ts">
interface UiBottomBarProps {
    variant?: 'default' | 'sticky'
    size?: 'md' | 'lg'
    noContainer?: boolean
}

const props = withDefaults(defineProps<UiBottomBarProps>(), {
    variant: 'default',
    size: 'md',
    noContainer: false,
})
</script>

<template>
    <div class="
        w-full
        bg-white 
        flex items-center
        border-t-1 border-solid border-se-gray-300" 
        :class="[
            props.size === 'md' && 'h-16',
            props.size === 'lg' && 'h-23',
            props.variant === 'sticky' && 'sticky bottom-0 z-50',
        ]"
        v-safe-area:bottom
    >
        <div class="
            flex items-center
            gap-10
            "
            :class="[
                props.noContainer ? 'px-4 md:px-8' : 'container mx-auto',
            ]">
            <slot />
        </div>
    </div>
</template>


